import React, { useReducer } from 'react';

import { useToasts } from 'react-toast-notifications'
import { successToast, errorToast, warningToast} from '../../../utils/ToastUtil'

import UsersAdminContext from './UsersAdminContext'
import UsersAdminReducer from './UsersAdminReducer'

import { 
    LOADING, 
    GET_USERS, 
    SAVE_USER, 
    SAVE_NEW_USER, 
    PATCH_ACCOUNT_USER,
    DISLABED_USER,
    SAVE_LIQUIDATION,
    DELETE_LIQUIDATION
 } from "../../../types";

import {allUsers, postUser, patchUser, disableUser} from "../../../http_services/admin/user"
import { saveLiquidation, dropLiquidation} from '../../../http_services/salarySettlement/index';

const UsersAdminState = (props) => {
    const { addToast } = useToasts();

    const initialState = {
        loading: false,
        users: [],
        userSelected: {}
    }    

    const [state, dispatch] = useReducer(UsersAdminReducer, initialState);

    const loadUsers = async () => {
        try{
            loading(); 
            const data = await allUsers();
            dispatch({
                type: GET_USERS,
                payload: data.data
            });
            loading();
        } catch(err) {
            
            addToast('Error al Tratar de obtener los Usuarios', errorToast());
            return null;
        }
    }

    const saveNewUser = async (user) => {
        try{
            loading(); 
            const data = await postUser(user);
            dispatch({
                type: SAVE_NEW_USER,
                payload: data.data
            });
            loading();
            addToast('Usuario Registrado con éxito', successToast());
            return data;
        } catch(err) {
            loading();
            addToast('Error al Registrar Usuario', errorToast());
            return null;
        }
    }

    const updateUserAdmin = async (user, email) => {
        try{
            loading(); 
            const data = await patchUser(user, email);
            dispatch({
                type: PATCH_ACCOUNT_USER,
                payload: data.data
            });
            loading();
            addToast('Usuario Actualizado con éxito', successToast());
            return data;
        } catch(err) {
            loading();
            if(err.response.status === 400){
                addToast(err.response.data.message, warningToast());
                return null;
            }
            addToast('Error al Actualizar el Usuario', errorToast());
            return null;
        }
    }

    const deleteUser = async (email) => {
        try{
            loading(); 
            const data = await disableUser(email);
            dispatch({
                type: DISLABED_USER,
                payload: email
            });
            loading();
            addToast('Usuario Eliminado con éxito', successToast());
            return data
        } catch(err) {
            loading();
            addToast('Error al tratar de Eliminar el Usuario', errorToast());
            return null;
        }
    }

    
    const addLiquidation = async(data) => {
        try{
            loading(); 
            const res = await saveLiquidation(data);    
            dispatch({
                type: SAVE_LIQUIDATION,
                payload: res.data
            });        
            loading();
            addToast('Liquidación agregada con éxito', successToast());
            return res;
        }catch(err){
            loading();
            addToast('Error al tratar de agregar la Liquidación', errorToast());
            return null;
        }
    }

    const deleteLiquidation = async(uuid) => {
        try{
            loading(); 
            const res = await dropLiquidation(uuid);
            dispatch({
                type: DELETE_LIQUIDATION,
                payload: uuid
            });       
            loading();
            addToast('Liquidación Eliminada con éxito', successToast());
            return res;
        }catch(err){
            loading();
            if(err.response.status > 400 && err.response.data.message){
                addToast(err.response.data.message, warningToast());
                return null;
            }
            addToast('Error al tratar de Eliminar la Liquidación', errorToast());
            return null;
        }
    }
    
    const cacheUserSelected = (user) => {    
        dispatch({
            type: SAVE_USER,
            payload: user
        });
    }

    const loading = () => {
        dispatch({
          type: LOADING
        });
      }

    return ( 
        <UsersAdminContext.Provider
            value={{
                loading: state.loading,
                users: state.users,
                userSelected: state.userSelected,
                loadUsers: loadUsers,
                cacheUserSelected: cacheUserSelected,
                saveNewUser: saveNewUser,
                updateUserAdmin: updateUserAdmin,
                deleteUser: deleteUser,
                addLiquidation: addLiquidation,
                deleteLiquidation: deleteLiquidation
            }}
        >
            {props.children}
        </UsersAdminContext.Provider>
     );
}
 
export default UsersAdminState;